__webpack_require__.hmrF = () => ("accordion." + __webpack_require__.h() + ".hot-update.json");